import { connect } from 'react-redux';
import { SupportedLanguage } from '../../../../config/constants/supportedLanguage.enum';
import { IReduxRootState } from '../../../reduxRootState.interface';
import { ICountry } from '../country/country';
import { CALLING_CODES } from './calling-codes';
import CallingCodeSelector, {
    ICallingCodeSelectorOwnProps,
    ICallingCodeSelectorStateProps,
} from './CallingCodeSelector';

const mapStateToProps = (state: IReduxRootState) => {
    const countries =
        (state.countries.countriesMap &&
            state.countries.countriesMap[state.app.locale as SupportedLanguage]) ||
        [];
    const countriesCallingCodes = Object.values(countries)
        .map((country: ICountry) => ({
            alpha2Code: country.alpha2Code,
            dialCode: CALLING_CODES[country.alpha2Code],
            name: country.name,
        }))
        .filter((countryCallingCode) => Boolean(countryCallingCode.dialCode));

    return {
        countriesCallingCodes,
    };
};

export default connect<
    ICallingCodeSelectorStateProps,
    {},
    ICallingCodeSelectorOwnProps,
    IReduxRootState
>(mapStateToProps)(CallingCodeSelector);
